module.exports = __webpack_public_path__ + "static/media/os.ede712e0.png";